import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import axios from 'axios';
import lifecodeLogo from './Lifecode-Final-logo-white.png';
import './App.css';

// Must match the key used in Form.js to remember an in-progress session
const LOCAL_SESSION_KEY = 'lifecode_questionnaire_session';

const Welcome = () => {
  const navigate = useNavigate();

  // If this browser has a saved, in-progress session, skip the welcome screen and
  // go straight to the form so the customer continues where they left off.
  const [checking, setChecking] = useState(() => {
    try { return !!localStorage.getItem(LOCAL_SESSION_KEY); } catch (e) { return false; }
  });

  useEffect(() => {
    let savedSessionId = null;
    try { savedSessionId = localStorage.getItem(LOCAL_SESSION_KEY); } catch (e) { /* storage disabled */ }

    if (!savedSessionId) {
      setChecking(false);
      return;
    }

    axios.get(`/api/session/${savedSessionId}/state`)
      .then(res => {
        if (res.data.valid && res.data.resumed) {
          // Has saved answers -> jump straight into the form (which restores them)
          navigate('/form', { replace: true });
        } else {
          // No usable progress (empty or already submitted) -> show the welcome screen
          if (!res.data.valid) {
            try { localStorage.removeItem(LOCAL_SESSION_KEY); } catch (e) { /* ignore */ }
          }
          setChecking(false);
        }
      })
      .catch(() => setChecking(false));
  }, [navigate]);

  if (checking) {
    return (
      <div className="welcome-container">
        <div className="welcome-content" style={{ textAlign: 'center' }}>
          <div className="loading-spinner"></div>
          <p>Loading your saved progress…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="welcome-container">
      <div className="welcome-content">
        <div className="logo-section">
          <div className="logo-text">
            <img src={lifecodeLogo} alt="Lifecode" className="logo-image" />
            
          </div>
        </div>

        <div className="welcome-message">
          <p>
            Thank you for taking the time to fill this form. It will take approximately 10 to 15 minutes to complete.
            Please read the instructions carefully before proceeding.
          </p>
        </div>

        <div className="instructions">
          <div className="important-notice">
            <strong>Important:</strong> Your progress is saved automatically as you go. If you need to step away,
            you can return on the <strong>same device and browser</strong> using this link to continue where you left off.
            For best results, please try to complete the form in one sitting.
          </div>
        </div>

        <div className="start-section">
          <div className="start-instruction">
            ✅ Click "Start" to begin.
          </div>
          <button onClick={() => navigate('/form')} className="start-button">
            Start <ArrowRight size={20} />
          </button>
        </div>


      </div>
    </div>
  );
};

export default Welcome;
